import { NgModule } from '@angular/core';
import { ICartCreationDialogService } from 'shared/services/ui/cart-creation-dialog/cart-creation-dialog-service.abstract';
import { IOrderCheckoutResultDialogService } from 'projects/shared/lib/interfaces/services/dialogs/checkout-result-dialog.service.abstract';
import { OfferPreviewApiServiceProvider } from 'projects/shared/lib/services/api/offer-preview/offer-preview-api.service';
import { ContextMHServiceProvider } from 'projects/munhowen/src/app/services/infrastructure/context.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AddressListDialogModule } from './components/shared/address/list-dialog/address-list-dialog.module';
import { BannerComponent } from 'shared/components/shared/banner/banner.component';
import { CartCreationDialogModule } from './components/shared/cart/cart-creation-dialog/cart-creation-dialog.module';
import { CheckoutResultDialogModule } from './components/shared/checkout/order/result-dialog/order-checkout-result-dialog.module';
import { ProductAddToCartListDialogModule } from './components/shared/dialog/product-add-to-cart-list-dialog/product-add-to-cart-list-dialog.module';
import { HeaderMHComponent } from './components/shared/header/header.component';
import { FooterMHComponent } from './components/shared/footer/footer.component';
import { SidebarCartModule } from './components/shared/sidebar/cart/sidebar-cart.module';
import { SidebarUserMHComponent } from './components/shared/sidebar/user/sidebar-user.component';
import { ToastContainerBaseComponent } from 'projects/shared/lib/components/shared/toast/container/toast-container.component';
import { UserInformationSetDialogMHComponent } from './components/shared/user/information-set-dialog/user-information-set-dialog.component';
import { UserPasswordSetDialogMHComponent } from './components/shared/user/password-set-dialog/user-password-set-dialog.component';
import { CartTourServiceProvider } from '../../../shared/lib/services/data/cart/cart-tour.service';
import { AddressListDialogServiceProvider } from './services/dialogs/address-list-dialog.service';
import { OrderCheckoutResultDialogService } from './services/dialogs/order-checkout-result-dialog.service';
import { ConfirmDialogServiceProvider } from './services/dialogs/confirm-dialog.service';
import { CookieInformationDialogServiceProvider } from './services/dialogs/cookie-information-dialog.service';
import { ProductDetailThumbnailDialogServiceProvider } from './services/dialogs/product-detail-thumbnail-dialog.service';
import { UserInformationSetDialogServiceProvider } from './services/dialogs/user-information-set-dialog.service';
import { UserPasswordSetDialogServiceProvider } from './services/dialogs/user-password-set-dialog.service';
import { ProductCategoryMHServiceProvider } from './services/data/product-category/product-category.service';
import { ProductAddToCartDialogServiceProvider } from './services/dialogs/product-add-to-cart-dialog.service';
import { EnumToIndexValueMapPipe } from 'projects/shared/lib/pipes/generic/enum-to-index-value-map/enum-to-index-value-map.pipe';
import { StickyFooterMobileModule } from './components/shared/sticky-footer/mobile/sticky-footer-mobile.module';
import { UserSwitchCustomerDialogService } from './services/dialogs/user-switch-customer-dialog.service';
import { UserSwitchCustomerDialogComponent } from 'projects/shared/lib/components/shared/user/switch-customer-dialog/user-switch-customer-dialog.component';
import { IUserSwitchCustomerDialogService } from 'shared/interfaces/services/dialogs/user-switch-customer-dialog-service.abstract';
import { IUserLoginCustomerSelectDialogService } from 'projects/shared/lib/interfaces/services/dialogs/user-login-customer-select-dialog-service.abstract';
import { UserLoginCustomerSelectDialogService } from './services/dialogs/user-login-customer-select-dialog.service';
import { UserLoginCustomerSelectDialogComponent } from 'projects/shared/lib/components/shared/user/user-login-customer-select-dialog/user-login-customer-select-dialog.component';
import { IProductAvailabilityNotificationConfirmationDialogService } from 'projects/shared/lib/interfaces/services/dialogs/product-availability-notification-confirmation-dialog-service.abstract';
import { ProductAvailabilityNotificationConfirmationDialogService } from './services/dialogs/product-availability-notification-confirmation-dialog.service';
import { UsernameAbbreviationPipe } from 'projects/shared/lib/pipes/username-abbreviation/username-abbreviation.pipe';
import { CartOffcanvasPreviewModule } from './components/shared/cart/cart-offcanvas-preview/cart-offcanvas-preview.module';
import { CalendarApiServiceProvider } from 'projects/shared/lib/services/api/calendar/calendar-api.service';
import { QuantityUnitToStringPipe } from 'projects/shared/lib/pipes/quantity-unit/quantity-unit-to-string.pipe';
import { SearchMHServiceProvider } from './services/ui/search.service';
import { AgeConfirmDialogServiceProvider } from './services/dialogs/age-confirm-dialog.service';
import { ReminderApiServiceProvider } from 'projects/shared/lib/services/api/reminder/reminder-api.service';
import { ReminderServiceProvider } from 'projects/shared/lib/services/data/reminder/reminder.service';
import { AvailabilityNotificationApiServiceProvider } from 'projects/shared/lib/services/api/availability-notification/availability-notification-api.service';
import { ContactRequestApiServiceProvider } from 'projects/shared/lib/services/api/contact-request/contact-request-api.service';
import { OfferApiServiceProvider } from 'projects/shared/lib/services/api/offer/offer-api.service';
import { AvailabilityNotificationServiceProvider } from 'projects/shared/lib/services/data/availability-notification/availability-notification.service';
import { ContactRequestServiceProvider } from 'projects/shared/lib/services/data/contact-request/contact-request.service';
import { SalesUnitServiceProvider } from 'projects/shared/lib/services/infrastructure/salesunit/salesunit.service';
import { CalendarServiceProvider } from 'projects/shared/lib/services/data/calendar/calendar.service';
import { CartCreationDialogService } from './services/ui/cart-creation-dialog.service';
import { AppCoreModule } from 'shared/app-core/app.module';
import { ProductAddToCartTemplateDialogMHServiceProvider } from './services/dialogs/product-add-to-cart-template-dialog.service';
import { APPTRANSLATIONS } from '../i18n/translations';

@NgModule({
  declarations: [
    AppComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    AppCoreModule, // includes CoreImports and CoreProviders
    // imports can't be removed once they're referenced from the CoreImports!
    // imports can't be overwritten once they're referenced from the CoreImports!

    AppRoutingModule,

    // Components used in AppComponent
    HeaderMHComponent,
    FooterMHComponent,
    ToastContainerBaseComponent,
    SidebarCartModule,
    SidebarUserMHComponent,
    BannerComponent,
    CartOffcanvasPreviewModule,

    // Dialogs used in the DialogService
    AddressListDialogModule,
    ProductAddToCartListDialogModule,
    UserPasswordSetDialogMHComponent,
    UserInformationSetDialogMHComponent,
    CartCreationDialogModule,
    CheckoutResultDialogModule,
    UserSwitchCustomerDialogComponent,
    UserLoginCustomerSelectDialogComponent,
    StickyFooterMobileModule
  ],
  providers: [
    // CoreProviders are imported and declared by importing the AppCoreModule! -> Defaults such as logger are provided

    // providers can't easily be removed from the core!
    // providers can be overwritten by re-providing/using the InjectionToken. -> simply provide the variant

    // Provide service implementations
    AddressListDialogServiceProvider,
    ConfirmDialogServiceProvider,
    AgeConfirmDialogServiceProvider,
    CookieInformationDialogServiceProvider,
    ProductAddToCartDialogServiceProvider,
    ProductDetailThumbnailDialogServiceProvider,
    UserInformationSetDialogServiceProvider,
    UserPasswordSetDialogServiceProvider,
    { provide: ICartCreationDialogService, useExisting: CartCreationDialogService },
    CartTourServiceProvider,
    ProductCategoryMHServiceProvider,
    OfferPreviewApiServiceProvider,
    { provide: IOrderCheckoutResultDialogService, useExisting: OrderCheckoutResultDialogService },
    { provide: IUserSwitchCustomerDialogService, useExisting: UserSwitchCustomerDialogService },
    { provide: IUserLoginCustomerSelectDialogService, useExisting: UserLoginCustomerSelectDialogService },
    ContextMHServiceProvider,
    // Calendar services
    CalendarApiServiceProvider,
    CalendarServiceProvider,
    { provide: EnumToIndexValueMapPipe, useFactory: () => new EnumToIndexValueMapPipe() },
    // { provide: CustomernamesToStringPipe, useFactory: () => new CustomernamesToStringPipe() },
    { provide: IProductAvailabilityNotificationConfirmationDialogService, useExisting: ProductAvailabilityNotificationConfirmationDialogService },
    { provide: UsernameAbbreviationPipe, useFactory: () => new UsernameAbbreviationPipe() },
    { provide: QuantityUnitToStringPipe, useFactory: () => new QuantityUnitToStringPipe() },
    SearchMHServiceProvider,
    ReminderApiServiceProvider,
    ReminderServiceProvider,
    ContactRequestApiServiceProvider,
    ContactRequestServiceProvider,
    AvailabilityNotificationApiServiceProvider,
    AvailabilityNotificationServiceProvider,
    OfferApiServiceProvider,
    SalesUnitServiceProvider,
    ProductAddToCartTemplateDialogMHServiceProvider
  ]
})
export class AppMHModule extends AppCoreModule {
  /**
   * the extension of the core module does not influence the imports / providers!
   * it calls the constructor which initializes the static ServiceLocator instance
   */

  constructor() {
    super();
    var dummy = APPTRANSLATIONS; // dummy reference, just so that the import line and the reference remains for i18n
  }
}
